export default __webpack_public_path__ + "static/media/new-copy-icon.a80f2b06.svg";